export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8722.49e2b927.jpg";